import { MAT_SELECT_SCROLL_STRATEGY, MatSelectModule } from '@angular/material/select';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { NgModule, LOCALE_ID } from '@angular/core';
import { CommonModule } from '@angular/common';

// Helpers
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { DemoMaterialModule } from '../helpers/material-modules';
import { CustomPaginator } from '../helpers/CustomPaginatorConfiguration';

import { LottieModule } from 'ngx-lottie';
import player from 'lottie-web';

// Note we need a separate function as it's required
// by the AOT compiler.
export function playerFactory() {
  return player;
}

import { Overlay, BlockScrollStrategy } from '@angular/cdk/overlay';

export function scrollFactory(overlay: Overlay): () => BlockScrollStrategy {
  return () => overlay.scrollStrategies.block();
}

import { RouterModule } from '@angular/router';
import { AccessControlDirective } from '../helpers/access-control.directive';
import { DropDownDirective } from '../helpers/drop-down.directive';
import { ShortNamePipe } from '../helpers/shortName.pipe';
import { TabNavRouteComponent } from './tab-nav-route/tab-nav-route.component';
import { OnlynumberDirective } from '../helpers/onlynumber.directive';
import { EmptyStateComponent } from './empty-state/empty-state.component';
import { TableMatComponent } from './table-mat/table-mat.component';
import { ToastrModule } from 'ngx-toastr';
import { SanitizeHtmlPipePipe } from '../helpers/sanitize-html-pipe.pipe';
import { BadgeStatusComponent } from './badge-status/badge-status.component';
import { NgxMatDatetimePickerModule, NgxMatNativeDateModule } from '@angular-material-components/datetime-picker';
import { FileManagerComponent } from './file-manager/file-manager.component';
import { FilesViewerComponent } from './files-viewer/files-viewer.component';
import { SidenavOverComponent } from './sidenav-over/sidenav-over.component';
import { ThemeCustomizerComponent } from './theme-customizer/theme-customizer.component';
import { TreeFieldComponent } from './tree-field/tree-field.component';
import { TreeSelectionComponent } from './tree-selection/tree-selection.component';
import { ChartStatisticComponent } from './chart-statistic/chart-statistic.component';
import { NgxChartsModule } from '@swimlane/ngx-charts';
import { ImportFileComponent } from './import-file/import-file.component';
import { QRCodeModule } from 'angularx-qrcode';
import { GatePassPrintComponent } from '../features/gate-management/gate-pass/gate-pass-print/gate-pass-print.component';
import { DateFormatPipe } from '../helpers/date-format.pipe';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MatExpansionModule } from '@angular/material/expansion';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { CustomDateReportPipe } from '../helpers/custom-date-report.pipe';



const components = [
  TabNavRouteComponent,
  EmptyStateComponent,
  TableMatComponent,
  BadgeStatusComponent,
  FileManagerComponent,
  FilesViewerComponent,
  SidenavOverComponent,
  ThemeCustomizerComponent,
  TreeFieldComponent,
  TreeSelectionComponent,
  ChartStatisticComponent,
  ImportFileComponent,
  GatePassPrintComponent
];

const directives = [
  DropDownDirective,
  AccessControlDirective,
  OnlynumberDirective
];
@NgModule({
  declarations: [
    // Directives
    directives,
    // Pipes
    ShortNamePipe,
    SanitizeHtmlPipePipe,
    DateFormatPipe,
    CustomDateReportPipe,
    // Components
    components
  ],
  imports: [
    CommonModule,
    DemoMaterialModule,
    TranslateModule.forChild({}),
    ReactiveFormsModule,
    FormsModule,
    RouterModule,
    LottieModule.forRoot({ player: playerFactory }),
    ToastrModule.forRoot(),
    NgxChartsModule,
    QRCodeModule,
    
    MatSelectModule,
    NgxMatSelectSearchModule
  ],
  exports: [
    // Directives
    directives,
    // Pipes
    ShortNamePipe,
    SanitizeHtmlPipePipe,
    DateFormatPipe,
    CustomDateReportPipe,
    // Components
    components,
    DemoMaterialModule,
    TranslateModule,
    ReactiveFormsModule,
    FormsModule,
    LottieModule,
    ToastrModule,
    NgxMatDatetimePickerModule,
    NgxMatNativeDateModule,
    NgxChartsModule,
    QRCodeModule,

    MatSelectModule,
    NgxMatSelectSearchModule
  ],
  providers: [
    { provide: MatPaginatorIntl, useValue: CustomPaginator() },
    { provide: MAT_SELECT_SCROLL_STRATEGY, useFactory: scrollFactory, deps: [Overlay] },
    { provide: LOCALE_ID, useValue: localStorage.getItem('language') || 'en' }
  ]
})
export class SharedModule { }
